import { envName } from "@faire/web/common/user-agent/envName";
import { isLocal } from "@faire/web/common/user-agent/isLocal";

export const isStaging = (): boolean => envName() === "staging" && !isLocal();
